class GiftCheckbox extends HTMLElement {
  constructor() {
    super();
    this.hasInitialized = false;
    this.fields = {
      _wishlist_id: null,
      _wishlist_name: null,
    };
  }

  connectedCallback() {
    if (this.hasInitialized) return;

    const params = new URLSearchParams(window.location.search);
    const giftlid = params.get('giftlid');
    const giftname = params.get('giftname');
    if (!giftlid || !giftname) return;

    this.classList.remove('hidden');

    const label = this.querySelector('label');
    if (label) {
      const labelText = label.textContent.replace('{{ gift_name }}', giftname);
      label.textContent = labelText;
    }

    const form = document.querySelector('.product-info-col product-form form');
    if (!form) return;

    this.createHiddenFields(form, giftlid, giftname);

    const checkbox = this.querySelector('input[type="checkbox"]');
    checkbox?.addEventListener('change', () => this.toggleFieldsState(checkbox.checked));

    this.hasInitialized = true;
  }

  createHiddenFields(form, giftlid, giftname) {
    const fieldConfig = [
      { name: '_wishlist_id', value: giftlid },
      { name: '_wishlist_name', value: giftname },
    ];

    fieldConfig.forEach(({ name, value }) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      input.value = value;

      this.fields[name] = input;
      form.appendChild(input);
    });
  }

  toggleFieldsState(isEnabled) {
    Object.values(this.fields).forEach((field) => {
      if (field) field.disabled = !isEnabled;
    });
  }
}

customElements.define('gift-checkbox', GiftCheckbox);
